import { UserPermissionObjectInfo } from "@skyportal/auth-web-client/dist";

export const sortCustomersByParentName = (list: UserPermissionObjectInfo[]): UserPermissionObjectInfo[] =>
  [...list].sort((a, b) => ((a.parentName as string).toLowerCase() >= (b.parentName as string).toLowerCase() ? 1 : -1));
